module.exports = __webpack_public_path__ + "img/⾼覆盖度的 ⽤户理解体系及知识图谱能⼒.1ec5e814.png";